module.exports = __webpack_public_path__ + "images/trauma.3e7224c9c59801e4b4bc494a479224cc.svg";